import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import 'popper.js';
import 'bootstrap'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import '../src/assets/css/fontawesome-free/css/all.min.css';
import '../src/assets/css/sb-admin-2.min.css';
import '../src/assets/js/jquery-easing/jquery.easing.min.js'
import AOS from 'aos'
import 'aos/dist/aos.css'
import $ from 'jquery'
import '../src/assets/js/sb-admin-2.min.js'

//window.$ = window.jquery = require('./node_modules/jquery');
//window.dt = require('./node_modules/datatables.net')();
//window.$('#table_id').DataTable();
const URL = require('./URL');
Vue.prototype.$http = axios


Vue.config.productionTip = false;

new Vue({
  created () {
    AOS.init()
  }, 
  router,
  store,
  URL,
  render: h => h(App)
}).$mount("#app");
